import { useIonViewWillEnter, IonRefresherContent, IonRefresher, IonInfiniteScrollContent, IonInfiniteScroll, IonList, IonChip, useIonRouter, IonIcon, IonTextarea, IonGrid, IonRow, IonText, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Clipboard } from '@capacitor/clipboard';
import { clipboardOutline } from 'ionicons/icons';

import NServer, { UIElement, RegisterAppServices } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";

import { NotiInfo } from "../data/item";
import Noti from "../components/Noti";

import './Main.css'; 

var index = 0;
const total = 25;
var unread = 0;

const Report : React.FC = () => {

    const router = useIonRouter();
    const [notis, setNotis] = useState<NotiInfo[]>([]);
    const [loading, setLoading] = useState(false);
    const [noMoreData, setNoMoreData] = useState(false);

    useIonViewWillEnter(() => {
        index = 0;

        RegisterAppServices();

        getData(unread);
    });

    const getData = async (un : number) => {

        setLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s: index,
            e: total,
            unread: un
        }

        unread = un;

        var server = new NServer();
        await server.getList("nc_noti", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            
            if (index == 0)
                setNotis(server.data);
            else
                setNotis(notis.concat(server.data));

            if (server.data.length < total)
                setNoMoreData(true);
        }
        
        setLoading(false);
    }

    // load more
    const loadMoreNoti = (ev: any) => {
        setTimeout(() => {
            // increase index
            index += total;

            getData(unread);

            ev.target.complete();
        }, 500);
    }  

    // refresh event
    const doRefresh = async (ev : any) => {
        setNoMoreData(false);
        index = 0;
        
        await getData(unread);

        ev.detail.complete();
    };

    // load all new
    const loadNew = async (un : number) => {
        setNoMoreData(false);
        index = 0;
        setNotis([]);

        await getData(un);
    }
    
    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar className="flat-card">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/mainc" ></IonBackButton>
                    </IonButtons>
                    <IonChip slot="end" onClick={()=>loadNew(1)}>{ GetStr(LANGUAGE.TXT_NOTI_UNREAD) }</IonChip>
                    <IonChip slot="end" onClick={()=>loadNew(0)}>{ GetStr(LANGUAGE.TXT_NOTI_SEE_ALL) }</IonChip>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonRefresher className="refresher" slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonList>
                    { 
                        notis.map((m) => 
                        <Noti key={m.id} noti={m} />
                        )
                    }
                </IonList>
                <IonInfiniteScroll
                    onIonInfinite={loadMoreNoti}
                    disabled={noMoreData}
                >
                    <IonInfiniteScrollContent
                        className="ion-no-padding"
                        loadingSpinner="crescent"
                    ></IonInfiniteScrollContent>
                </IonInfiniteScroll>
            </IonContent>
        </IonPage>
    );
};

export default Report;